import dynamic from 'next/dynamic';

import { PlatformID } from '@common/clients/api';
import { useContextData } from '@common/useContextData';

const FieldVi = dynamic(() =>
    import('@common/svg/images/generated/react/FieldVi').then((mod) => mod.default),
);

const FieldVp = dynamic(() =>
    import('@common/svg/images/generated/react/FieldVp').then((mod) => mod.default),
);

interface Props {
    className: string;
}

export const Field = (props: Props): React.ReactElement => {
    const { platform } = useContextData();

    return platform.id === PlatformID.VI ? <FieldVi {...props} /> : <FieldVp {...props} />;
};
